import React, { useEffect } from "react";
import $ from "jquery";
import { t } from "i18next";




export default function Faq(props) {

    // Declaration of project constant
    const { showFaq ,setShowFaq} = props;

    // Hide or show modal
    useEffect(() => {
        if (showFaq === true) {
            $(".modal-faq").fadeIn();
        } else {
            $(".modal-faq").fadeOut();
        }
    }, [showFaq])

    // Hide modal
    function close() {
        $(".modal-faq").fadeOut();
        setShowFaq(false)
    }

    return (
        <div className="modal modal-faq">
            <div id="modal-faq" className="modal-content" style={{ height: '97%', overflow: 'auto' }}>
                <div style={{ textAlign: 'right' }}>
                    <i onClick={()=>close()} className="icon ion-android-close close" id="close-user-edit" style={{ color: 'inherit', float: 'right', fontWeight: 'bold', cursor: 'pointer', position: 'relative', top: '0px', left: '20px' }} />
                </div>
                <div className="mb-3" style={{ border: 'none', padding: 0, fontSize: '1.4em' }}>
                    <h3 className="fw-700 lang mb-0" keyword="new-location">FAQ</h3><span style={{ fontSize: '0.75em' }}>08
                        sujets total</span>
                </div>
                <div className="display of-a pr-3" style={{ display: 'block', height: "90%" }}>
                    <h5 className="fw-700">{t("fee_tax_time")}</h5>
                    <p className="mb-4">{t("no_extra_fee")}</p>
                    <h5 className="fw-700">{t("what_if")}</h5>
                    <p className="mb-4">{t("After_purchase_wait")}
                        <strong>  5min {t("maximum")}</strong>{t("before_activation")}&nbsp;{t("this_period")}&nbsp;<strong>696 26 26 26 / 670 55 78 78</strong> {t("transaction_number")}<strong>  '{t("My_transactions")}'</strong>.
                    </p>
                    <h5 className="fw-700">{t("less_refill")}</h5>
                    <p className="mb-4">{t("may_be_error")}</p>
                    <h5 className="fw-700">{t("payment_secure")}</h5>
                    <p className="mb-0">{t("Indeed_secure")}<strong>Glotelho
                        Pay.&nbsp;</strong><br />{t("All_info")}&nbsp;<strong>{t("Protected_and_encrypted")}</strong>&nbsp; {t("by_the")} &nbsp;<strong>protocole
                            SSL</strong>&nbsp;(Secure
                        Sockets Layer).<br /></p>
                </div>
            </div>
        </div>
    );
}
